//
// Copyright 2025 DXOS.org
//
import { createComponent } from '@lit/react';
import React from 'react';
import { DX_ANCHOR_ACTIVATE } from '@dxos/ui-types';
import { DxAnchor as NaturalDxAnchor, DxAvatar as NaturalDxAvatar, DxTagPickerItem as NaturalDxTagPickerItem, DxIcon as NaturalIcon, } from './index';
export const DxAnchor = createComponent({
    tagName: 'dx-anchor',
    elementClass: NaturalDxAnchor,
    react: React,
    events: {
        onActivate: DX_ANCHOR_ACTIVATE,
    },
});
export const DxAvatar = createComponent({
    tagName: 'dx-avatar',
    elementClass: NaturalDxAvatar,
    react: React,
});
export const DxIcon = createComponent({
    tagName: 'dx-icon',
    elementClass: NaturalIcon,
    react: React,
});
export const DxTagPickerItem = createComponent({
    tagName: 'dx-tag-picker-item',
    elementClass: NaturalDxTagPickerItem,
    react: React,
    events: {
        onItemClick: 'dx-tag-picker-item-click',
    },
});
export { createComponent };
//# sourceMappingURL=react.js.map